"use client";
import useCapturePageHit from "@/hooks/useCapturePageHit";

const CapturePageHit = () => {
  useCapturePageHit();
  return null;
};

export default CapturePageHit;
